import { useEffect, useState } from "react";

const BREAKPOINTS = {
  tabletSmall: "(max-width: 1000px)",
  mobile: "(max-width: 640px)",
};

export const useScreenSize = () => {
  const [isTabletSmallView, setIsTabletSmallView] = useState(
    () => window.matchMedia(BREAKPOINTS.tabletSmall).matches
  );
  const [isMobileView, setIsMobileView] = useState(
    () => window.matchMedia(BREAKPOINTS.mobile).matches
  );

  useEffect(() => {
    const tabletQuery = window.matchMedia(BREAKPOINTS.tabletSmall);
    const mobileQuery = window.matchMedia(BREAKPOINTS.mobile);

    const onTabletChange = (e) => setIsTabletSmallView(e.matches);
    const onMobileChange = (e) => setIsMobileView(e.matches);

    tabletQuery.addEventListener("change", onTabletChange);
    mobileQuery.addEventListener("change", onMobileChange);

    return () => {
      tabletQuery.removeEventListener("change", onTabletChange);
      mobileQuery.removeEventListener("change", onMobileChange);
    };
  }, []);

  return { isTabletSmallView, isMobileView };
};
